// GeoLanguageService.js - Module harmonisé avec les services backend
// Cohérent avec LanguageService.js et GeoLocalizer.js

// ============================================================================
// LANGUES DISPONIBLES (harmonisé avec LanguageService.SUPPORTED_LANGUAGES)
// ============================================================================
export const AVAILABLE_LANGUAGES = [
    { code: 'ar', name: 'Arabe', rtl: true },
    { code: 'bg', name: 'Bulgare', rtl: false },
    { code: 'cs', name: 'Tchèque', rtl: false },
    { code: 'da', name: 'Danois', rtl: false },
    { code: 'de', name: 'Allemand', rtl: false },
    { code: 'el', name: 'Grec', rtl: false },
    { code: 'en', name: 'Anglais', rtl: false },
    { code: 'es', name: 'Espagnol', rtl: false },
    { code: 'et', name: 'Estonien', rtl: false },
    { code: 'fi', name: 'Finnois', rtl: false },
    { code: 'fr', name: 'Français', rtl: false },
    { code: 'he', name: 'Hébreu', rtl: true },
    { code: 'hr', name: 'Croate', rtl: false },
    { code: 'hu', name: 'Hongrois', rtl: false },
    { code: 'id', name: 'Indonésien', rtl: false },
    { code: 'it', name: 'Italien', rtl: false },
    { code: 'ja', name: 'Japonais', rtl: false },
    { code: 'ko', name: 'Coréen', rtl: false },
    { code: 'lt', name: 'Lituanien', rtl: false },
    { code: 'lv', name: 'Letton', rtl: false },
    { code: 'nl', name: 'Néerlandais', rtl: false },
    { code: 'no', name: 'Norvégien', rtl: false },
    { code: 'pl', name: 'Polonais', rtl: false },
    { code: 'pt', name: 'Portugais', rtl: false },
    { code: 'ro', name: 'Roumain', rtl: false },
    { code: 'ru', name: 'Russe', rtl: false },
    { code: 'sk', name: 'Slovaque', rtl: false },
    { code: 'sl', name: 'Slovène', rtl: false },
    { code: 'sv', name: 'Suédois', rtl: false },
    { code: 'tr', name: 'Turc', rtl: false },
    { code: 'uk', name: 'Ukrainien', rtl: false },
    { code: 'zh', name: 'Chinois', rtl: false }
  ];
  
  // ============================================================================
  // PAYS DISPONIBLES (triés par ordre alphabétique)
  // ============================================================================
  export const AVAILABLE_COUNTRIES = [
    { code: '', name: 'Non spécifié (mondial)', region: 'Global' },
    { code: 'ZA', name: 'Afrique du Sud', region: 'Africa' },
    { code: 'DE', name: 'Allemagne', region: 'Europe' },
    { code: 'DZ', name: 'Algérie', region: 'North Africa' },
    { code: 'SA', name: 'Arabie saoudite', region: 'Middle East' },
    { code: 'AR', name: 'Argentine', region: 'South America' },
    { code: 'AU', name: 'Australie', region: 'Oceania' },
    { code: 'AT', name: 'Autriche', region: 'Europe' },
    { code: 'BE', name: 'Belgique', region: 'Europe' },
    { code: 'BR', name: 'Brésil', region: 'South America' },
    { code: 'BG', name: 'Bulgarie', region: 'Europe' },
    { code: 'CA', name: 'Canada', region: 'North America' },
    { code: 'CL', name: 'Chili', region: 'South America' },
    { code: 'CN', name: 'Chine', region: 'Asia' },
    { code: 'CO', name: 'Colombie', region: 'South America' },
    { code: 'KR', name: 'Corée du Sud', region: 'Asia' },
    { code: 'CI', name: 'Côte d\'Ivoire', region: 'Africa' },
    { code: 'HR', name: 'Croatie', region: 'Europe' },
    { code: 'DK', name: 'Danemark', region: 'Europe' },
    { code: 'EG', name: 'Égypte', region: 'Middle East & North Africa' },
    { code: 'AE', name: 'Émirats arabes unis', region: 'Middle East' },
    { code: 'ES', name: 'Espagne', region: 'Europe' },
    { code: 'EE', name: 'Estonie', region: 'Europe' },
    { code: 'US', name: 'États-Unis', region: 'North America' },
    { code: 'FI', name: 'Finlande', region: 'Europe' },
    { code: 'FR', name: 'France', region: 'Europe' },
    { code: 'GH', name: 'Ghana', region: 'Africa' },
    { code: 'GR', name: 'Grèce', region: 'Europe' },
    { code: 'HU', name: 'Hongrie', region: 'Europe' },
    { code: 'IN', name: 'Inde', region: 'Asia' },
    { code: 'ID', name: 'Indonésie', region: 'Asia' },
    { code: 'IE', name: 'Irlande', region: 'Europe' },
    { code: 'IL', name: 'Israël', region: 'Middle East' },
    { code: 'IT', name: 'Italie', region: 'Europe' },
    { code: 'JP', name: 'Japon', region: 'Asia' },
    { code: 'JO', name: 'Jordanie', region: 'Middle East' },
    { code: 'KE', name: 'Kenya', region: 'Africa' },
    { code: 'LV', name: 'Lettonie', region: 'Europe' },
    { code: 'LB', name: 'Liban', region: 'Middle East' },
    { code: 'LT', name: 'Lituanie', region: 'Europe' },
    { code: 'MY', name: 'Malaisie', region: 'Asia' },
    { code: 'MA', name: 'Maroc', region: 'North Africa' },
    { code: 'MX', name: 'Mexique', region: 'North America' },
    { code: 'NG', name: 'Nigeria', region: 'Africa' },
    { code: 'NO', name: 'Norvège', region: 'Europe' },
    { code: 'NZ', name: 'Nouvelle-Zélande', region: 'Oceania' },
    { code: 'NL', name: 'Pays-Bas', region: 'Europe' },
    { code: 'PE', name: 'Pérou', region: 'South America' },
    { code: 'PH', name: 'Philippines', region: 'Asia' },
    { code: 'PL', name: 'Pologne', region: 'Europe' },
    { code: 'PT', name: 'Portugal', region: 'Europe' },
    { code: 'CZ', name: 'République tchèque', region: 'Europe' },
    { code: 'RO', name: 'Roumanie', region: 'Europe' },
    { code: 'UK', name: 'Royaume-Uni', region: 'Europe' },
    { code: 'RU', name: 'Russie', region: 'Europe & Asia' },
    { code: 'SN', name: 'Sénégal', region: 'Africa' },
    { code: 'SG', name: 'Singapour', region: 'Asia' },
    { code: 'SK', name: 'Slovaquie', region: 'Europe' },
    { code: 'SI', name: 'Slovénie', region: 'Europe' },
    { code: 'SE', name: 'Suède', region: 'Europe' },
    { code: 'CH', name: 'Suisse', region: 'Europe' },
    { code: 'TH', name: 'Thaïlande', region: 'Asia' },
    { code: 'TN', name: 'Tunisie', region: 'North Africa' },
    { code: 'TR', name: 'Turquie', region: 'Europe & Asia' },
    { code: 'UA', name: 'Ukraine', region: 'Europe' },
    { code: 'UY', name: 'Uruguay', region: 'South America' },
    { code: 'VE', name: 'Venezuela', region: 'South America' },
    { code: 'VN', name: 'Vietnam', region: 'Asia' }
  ];
  
  // ============================================================================
  // CONFIGURATION PAR PAYS (harmonisée avec GeoLocalizer.COUNTRY_CONFIG)
  // ============================================================================
  export const COUNTRY_LANGUAGE_CONFIG = {
    // Europe
    'FR': { primary: ['fr'], secondary: ['en'], name: 'France', domains: ['.fr'], region: 'Europe' },
    'DE': { primary: ['de'], secondary: ['en'], name: 'Allemagne', domains: ['.de'], region: 'Europe' },
    'IT': { primary: ['it'], secondary: ['en'], name: 'Italie', domains: ['.it'], region: 'Europe' },
    'ES': { primary: ['es'], secondary: ['en'], name: 'Espagne', domains: ['.es'], region: 'Europe' },
    'UK': { primary: ['en'], secondary: [], name: 'Royaume-Uni', domains: ['.uk', '.co.uk'], region: 'Europe' },
    'NL': { primary: ['nl'], secondary: ['en'], name: 'Pays-Bas', domains: ['.nl'], region: 'Europe' },
    'BE': { primary: ['nl', 'fr'], secondary: ['de'], name: 'Belgique', domains: ['.be'], region: 'Europe' },
    'CH': { primary: ['de', 'fr', 'it'], secondary: ['en'], name: 'Suisse', domains: ['.ch'], region: 'Europe' },
    'AT': { primary: ['de'], secondary: ['en'], name: 'Autriche', domains: ['.at'], region: 'Europe' },
    'PL': { primary: ['pl'], secondary: ['en'], name: 'Pologne', domains: ['.pl'], region: 'Europe' },
    'SE': { primary: ['sv'], secondary: ['en'], name: 'Suède', domains: ['.se'], region: 'Europe' },
    'NO': { primary: ['no'], secondary: ['en'], name: 'Norvège', domains: ['.no'], region: 'Europe' },
    'DK': { primary: ['da'], secondary: ['en'], name: 'Danemark', domains: ['.dk'], region: 'Europe' },
    'FI': { primary: ['fi'], secondary: ['sv', 'en'], name: 'Finlande', domains: ['.fi'], region: 'Europe' },
    'PT': { primary: ['pt'], secondary: ['en'], name: 'Portugal', domains: ['.pt'], region: 'Europe' },
    'GR': { primary: ['el'], secondary: ['en'], name: 'Grèce', domains: ['.gr'], region: 'Europe' },
    'CZ': { primary: ['cs'], secondary: ['en'], name: 'République tchèque', domains: ['.cz'], region: 'Europe' },
    'HU': { primary: ['hu'], secondary: ['en'], name: 'Hongrie', domains: ['.hu'], region: 'Europe' },
    'RO': { primary: ['ro'], secondary: ['en'], name: 'Roumanie', domains: ['.ro'], region: 'Europe' },
    'BG': { primary: ['bg'], secondary: ['en'], name: 'Bulgarie', domains: ['.bg'], region: 'Europe' },
    'HR': { primary: ['hr'], secondary: ['en'], name: 'Croatie', domains: ['.hr'], region: 'Europe' },
    'SK': { primary: ['sk'], secondary: ['en'], name: 'Slovaquie', domains: ['.sk'], region: 'Europe' },
    'SI': { primary: ['sl'], secondary: ['en'], name: 'Slovénie', domains: ['.si'], region: 'Europe' },
    'LT': { primary: ['lt'], secondary: ['en'], name: 'Lituanie', domains: ['.lt'], region: 'Europe' },
    'LV': { primary: ['lv'], secondary: ['en'], name: 'Lettonie', domains: ['.lv'], region: 'Europe' },
    'EE': { primary: ['et'], secondary: ['en'], name: 'Estonie', domains: ['.ee'], region: 'Europe' },
    'IE': { primary: ['en'], secondary: [], name: 'Irlande', domains: ['.ie'], region: 'Europe' },
    'RU': { primary: ['ru'], secondary: ['en'], name: 'Russie', domains: ['.ru'], region: 'Europe & Asia' },
    'UA': { primary: ['uk'], secondary: ['ru', 'en'], name: 'Ukraine', domains: ['.ua'], region: 'Europe' },
    
    // Amérique du Nord
    'US': { primary: ['en'], secondary: ['es'], name: 'États-Unis', domains: ['.com', '.gov', '.edu'], region: 'North America' },
    'CA': { primary: ['en', 'fr'], secondary: [], name: 'Canada', domains: ['.ca'], region: 'North America' },
    'MX': { primary: ['es'], secondary: ['en'], name: 'Mexique', domains: ['.mx'], region: 'North America' },
    
    // Amérique du Sud
    'BR': { primary: ['pt'], secondary: ['en'], name: 'Brésil', domains: ['.br'], region: 'South America' },
    'AR': { primary: ['es'], secondary: ['en'], name: 'Argentine', domains: ['.ar'], region: 'South America' },
    'CL': { primary: ['es'], secondary: ['en'], name: 'Chili', domains: ['.cl'], region: 'South America' },
    'CO': { primary: ['es'], secondary: ['en'], name: 'Colombie', domains: ['.co'], region: 'South America' },
    'PE': { primary: ['es'], secondary: ['en'], name: 'Pérou', domains: ['.pe'], region: 'South America' },
    'VE': { primary: ['es'], secondary: ['en'], name: 'Venezuela', domains: ['.ve'], region: 'South America' },
    'UY': { primary: ['es'], secondary: ['en'], name: 'Uruguay', domains: ['.uy'], region: 'South America' },
    
    // Asie
    'CN': { primary: ['zh'], secondary: ['en'], name: 'Chine', domains: ['.cn'], region: 'Asia' },
    'JP': { primary: ['ja'], secondary: ['en'], name: 'Japon', domains: ['.jp'], region: 'Asia' },
    'KR': { primary: ['ko'], secondary: ['en'], name: 'Corée du Sud', domains: ['.kr'], region: 'Asia' },
    'IN': { primary: ['en', 'hi'], secondary: [], name: 'Inde', domains: ['.in'], region: 'Asia' },
    'ID': { primary: ['id'], secondary: ['en'], name: 'Indonésie', domains: ['.id'], region: 'Asia' },
    'TH': { primary: ['th'], secondary: ['en'], name: 'Thaïlande', domains: ['.th'], region: 'Asia' },
    'VN': { primary: ['vi'], secondary: ['en'], name: 'Vietnam', domains: ['.vn'], region: 'Asia' },
    'MY': { primary: ['ms'], secondary: ['en'], name: 'Malaisie', domains: ['.my'], region: 'Asia' },
    'SG': { primary: ['en'], secondary: [], name: 'Singapour', domains: ['.sg'], region: 'Asia' },
    'PH': { primary: ['en'], secondary: [], name: 'Philippines', domains: ['.ph'], region: 'Asia' },
    'TR': { primary: ['tr'], secondary: ['en'], name: 'Turquie', domains: ['.tr'], region: 'Europe & Asia' },
    
    // Moyen-Orient
    'IL': { primary: ['he'], secondary: ['ar', 'en'], name: 'Israël', domains: ['.il'], region: 'Middle East' },
    'AE': { primary: ['ar'], secondary: ['en'], name: 'Émirats arabes unis', domains: ['.ae'], region: 'Middle East' },
    'SA': { primary: ['ar'], secondary: ['en'], name: 'Arabie saoudite', domains: ['.sa'], region: 'Middle East' },
    'EG': { primary: ['ar'], secondary: ['en'], name: 'Égypte', domains: ['.eg'], region: 'Middle East & North Africa' },
    'JO': { primary: ['ar'], secondary: ['en'], name: 'Jordanie', domains: ['.jo'], region: 'Middle East' },
    'LB': { primary: ['ar'], secondary: ['fr', 'en'], name: 'Liban', domains: ['.lb'], region: 'Middle East' },
    
    // Afrique du Nord
    'MA': { primary: ['ar', 'fr'], secondary: ['en'], name: 'Maroc', domains: ['.ma'], region: 'North Africa' },
    'DZ': { primary: ['ar'], secondary: ['fr', 'en'], name: 'Algérie', domains: ['.dz'], region: 'North Africa' },
    'TN': { primary: ['ar'], secondary: ['fr', 'en'], name: 'Tunisie', domains: ['.tn'], region: 'North Africa' },
    
    // Afrique subsaharienne
    'ZA': { primary: ['en'], secondary: [], name: 'Afrique du Sud', domains: ['.za'], region: 'Africa' },
    'NG': { primary: ['en'], secondary: [], name: 'Nigeria', domains: ['.ng'], region: 'Africa' },
    'KE': { primary: ['en'], secondary: [], name: 'Kenya', domains: ['.ke'], region: 'Africa' },
    'GH': { primary: ['en'], secondary: [], name: 'Ghana', domains: ['.gh'], region: 'Africa' },
    'SN': { primary: ['fr'], secondary: ['en'], name: 'Sénégal', domains: ['.sn'], region: 'Africa' },
    'CI': { primary: ['fr'], secondary: ['en'], name: 'Côte d\'Ivoire', domains: ['.ci'], region: 'Africa' },
    
    // Océanie
    'AU': { primary: ['en'], secondary: [], name: 'Australie', domains: ['.au'], region: 'Oceania' },
    'NZ': { primary: ['en'], secondary: [], name: 'Nouvelle-Zélande', domains: ['.nz'], region: 'Oceania' }
  };
  
  // ============================================================================
  // FONCTIONS UTILITAIRES (compatibles avec les services backend)
  // ============================================================================
  
  /**
   * Obtient les informations d'une langue par son code
   */
  export const getLanguageInfo = (langCode) => {
    return AVAILABLE_LANGUAGES.find(lang => lang.code === langCode);
  };
  
  /**
   * Obtient les informations d'un pays par son code
   */
  export const getCountryInfo = (countryCode) => {
    if (!countryCode) return null;
    
    const countryInList = AVAILABLE_COUNTRIES.find(country => country.code === countryCode);
    if (countryInList) return countryInList;
    
    const config = COUNTRY_LANGUAGE_CONFIG[countryCode];
    if (config) {
      return {
        code: countryCode,
        name: config.name,
        region: config.region
      };
    }
    
    return null;
  };
  
  /**
   * Obtient les langues recommandées pour un pays
   * HARMONISÉ avec GeoLocalizer.COUNTRY_CONFIG du backend
   */
  export const getRecommendedLanguages = (countryCode) => {
    const config = COUNTRY_LANGUAGE_CONFIG[countryCode];
    if (!config) {
      // Fallback vers GeoLocalizer backend si disponible
      const backendCountry = BACKEND_COUNTRY_MAPPING[countryCode];
      if (backendCountry) {
        return [backendCountry.language, 'en'].filter(lang => isLanguageSupported(lang));
      }
      return ['en'];
    }
    
    return [...config.primary, ...config.secondary];
  };
  
  // ============================================================================
  // CORRESPONDANCE AVEC GEOLOCALIZER BACKEND
  // ============================================================================
  export const BACKEND_COUNTRY_MAPPING = {
    // Extraction des correspondances principales du GeoLocalizer backend
    'AD': { language: 'ca', domains: ['.ad'] }, // Andorra - Catalan non supporté, fallback français
    'AE': { language: 'ar', domains: ['.ae'] }, // UAE
    'AF': { language: 'fa', domains: ['.af'] }, // Afghanistan - Farsi non supporté, fallback anglais
    'AL': { language: 'sq', domains: ['.al'] }, // Albania - Albanian non supporté, fallback anglais
    'AM': { language: 'hy', domains: ['.am'] }, // Armenia - Armenian non supporté, fallback anglais
    'AO': { language: 'pt', domains: ['.ao'] }, // Angola
    'AR': { language: 'es', domains: ['.ar'] }, // Argentina
    'AT': { language: 'de', domains: ['.at'] }, // Austria
    'AU': { language: 'en', domains: ['.au'] }, // Australia
    'AZ': { language: 'az', domains: ['.az'] }, // Azerbaijan - Azeri non supporté, fallback anglais
    'BA': { language: 'bs', domains: ['.ba'] }, // Bosnia - Bosnian non supporté, fallback croate
    'BB': { language: 'en', domains: ['.bb'] }, // Barbados
    'BD': { language: 'bn', domains: ['.bd'] }, // Bangladesh - Bengali non supporté, fallback anglais
    'BE': { language: 'nl', domains: ['.be'] }, // Belgium
    'BF': { language: 'fr', domains: ['.bf'] }, // Burkina Faso
    'BG': { language: 'bg', domains: ['.bg'] }, // Bulgaria
    'BH': { language: 'ar', domains: ['.bh'] }, // Bahrain
    'BI': { language: 'fr', domains: ['.bi'] }, // Burundi
    'BJ': { language: 'fr', domains: ['.bj'] }, // Benin
    'BN': { language: 'ms', domains: ['.bn'] }, // Brunei - Malay non supporté, fallback anglais
    'BO': { language: 'es', domains: ['.bo'] }, // Bolivia
    'BR': { language: 'pt', domains: ['.br'] }, // Brazil
    'BS': { language: 'en', domains: ['.bs'] }, // Bahamas
    'BT': { language: 'dz', domains: ['.bt'] }, // Bhutan - Dzongkha non supporté, fallback anglais
    'BW': { language: 'en', domains: ['.bw'] }, // Botswana
    'BY': { language: 'be', domains: ['.by'] }, // Belarus - Belarusian non supporté, fallback russe
    'BZ': { language: 'en', domains: ['.bz'] }, // Belize
    'CA': { language: 'en', domains: ['.ca'] }, // Canada
    'CD': { language: 'fr', domains: ['.cd'] }, // Democratic Republic of the Congo
    'CF': { language: 'fr', domains: ['.cf'] }, // Central African Republic
    'CG': { language: 'fr', domains: ['.cg'] }, // Republic of the Congo
    'CH': { language: 'de', domains: ['.ch'] }, // Switzerland
    'CI': { language: 'fr', domains: ['.ci'] }, // Ivory Coast
    'CL': { language: 'es', domains: ['.cl'] }, // Chile
    'CM': { language: 'fr', domains: ['.cm'] }, // Cameroon
    'CN': { language: 'zh', domains: ['.cn', '.中国'] }, // China
    'CO': { language: 'es', domains: ['.co'] }, // Colombia
    'CR': { language: 'es', domains: ['.cr'] }, // Costa Rica
    'CU': { language: 'es', domains: ['.cu'] }, // Cuba
    'CV': { language: 'pt', domains: ['.cv'] }, // Cape Verde
    'CY': { language: 'el', domains: ['.cy'] }, // Cyprus
    'CZ': { language: 'cs', domains: ['.cz'] }, // Czech Republic
    'DE': { language: 'de', domains: ['.de'] }, // Germany
    'DJ': { language: 'fr', domains: ['.dj'] }, // Djibouti
    'DK': { language: 'da', domains: ['.dk'] }, // Denmark
    'DO': { language: 'es', domains: ['.do'] }, // Dominican Republic
    'DZ': { language: 'ar', domains: ['.dz'] }, // Algeria
    'EC': { language: 'es', domains: ['.ec'] }, // Ecuador
    'EE': { language: 'et', domains: ['.ee'] }, // Estonia
    'EG': { language: 'ar', domains: ['.eg'] }, // Egypt
    'ER': { language: 'ti', domains: ['.er'] }, // Eritrea - Tigrinya non supporté, fallback anglais
    'ES': { language: 'es', domains: ['.es'] }, // Spain
    'ET': { language: 'am', domains: ['.et'] }, // Ethiopia - Amharic non supporté, fallback anglais
    'FI': { language: 'fi', domains: ['.fi'] }, // Finland
    'FJ': { language: 'en', domains: ['.fj'] }, // Fiji
    'FR': { language: 'fr', domains: ['.fr'] }, // France
    'GA': { language: 'fr', domains: ['.ga'] }, // Gabon
    'GB': { language: 'en', domains: ['.uk', '.co.uk', '.gov.uk'] }, // United Kingdom
    'UK': { language: 'en', domains: ['.uk', '.co.uk', '.gov.uk'] }, // United Kingdom (alias)
    'GE': { language: 'ka', domains: ['.ge'] }, // Georgia - Georgian non supporté, fallback anglais
    'GH': { language: 'en', domains: ['.gh'] }, // Ghana
    'GR': { language: 'el', domains: ['.gr'] }, // Greece
    'GT': { language: 'es', domains: ['.gt'] }, // Guatemala
    'GY': { language: 'en', domains: ['.gy'] }, // Guyana
    'HK': { language: 'zh', domains: ['.hk'] }, // Hong Kong
    'HN': { language: 'es', domains: ['.hn'] }, // Honduras
    'HR': { language: 'hr', domains: ['.hr'] }, // Croatia
    'HT': { language: 'ht', domains: ['.ht'] }, // Haiti - Haitian Creole non supporté, fallback français
    'HU': { language: 'hu', domains: ['.hu'] }, // Hungary
    'ID': { language: 'id', domains: ['.id'] }, // Indonesia
    'IE': { language: 'ga', domains: ['.ie'] }, // Ireland - Irish Gaelic non supporté, fallback anglais
    'IL': { language: 'he', domains: ['.il'] }, // Israel
    'IN': { language: 'hi', domains: ['.in'] }, // India - Hindi non supporté, fallback anglais
    'IQ': { language: 'ar', domains: ['.iq'] }, // Iraq
    'IR': { language: 'fa', domains: ['.ir'] }, // Iran - Farsi non supporté, fallback anglais
    'IS': { language: 'is', domains: ['.is'] }, // Iceland - Icelandic non supporté, fallback anglais
    'IT': { language: 'it', domains: ['.it'] }, // Italy
    'JM': { language: 'en', domains: ['.jm'] }, // Jamaica
    'JO': { language: 'ar', domains: ['.jo'] }, // Jordan
    'JP': { language: 'ja', domains: ['.jp'] }, // Japan
    'KE': { language: 'sw', domains: ['.ke'] }, // Kenya - Swahili non supporté, fallback anglais
    'KG': { language: 'ky', domains: ['.kg'] }, // Kyrgyzstan - Kyrgyz non supporté, fallback russe
    'KH': { language: 'km', domains: ['.kh'] }, // Cambodia - Khmer non supporté, fallback anglais
    'KP': { language: 'ko', domains: ['.kp'] }, // North Korea
    'KR': { language: 'ko', domains: ['.kr'] }, // South Korea
    'KW': { language: 'ar', domains: ['.kw'] }, // Kuwait
    'KZ': { language: 'kk', domains: ['.kz'] }, // Kazakhstan - Kazakh non supporté, fallback russe
    'LA': { language: 'lo', domains: ['.la'] }, // Laos - Lao non supporté, fallback anglais
    'LB': { language: 'ar', domains: ['.lb'] }, // Lebanon
    'LI': { language: 'de', domains: ['.li'] }, // Liechtenstein
    'LK': { language: 'si', domains: ['.lk'] }, // Sri Lanka - Sinhala non supporté, fallback anglais
    'LR': { language: 'en', domains: ['.lr'] }, // Liberia
    'LS': { language: 'st', domains: ['.ls'] }, // Lesotho - Sesotho non supporté, fallback anglais
    'LT': { language: 'lt', domains: ['.lt'] }, // Lithuania
    'LU': { language: 'lb', domains: ['.lu'] }, // Luxembourg - Luxembourgish non supporté, fallback français
    'LV': { language: 'lv', domains: ['.lv'] }, // Latvia
    'LY': { language: 'ar', domains: ['.ly'] }, // Libya
    'MA': { language: 'ar', domains: ['.ma'] }, // Morocco - Note: GeoLocalizer dit 'fr' mais officiellement c'est arabe
    'MC': { language: 'fr', domains: ['.mc'] }, // Monaco
    'MD': { language: 'ro', domains: ['.md'] }, // Moldova
    'ME': { language: 'sr', domains: ['.me'] }, // Montenegro - Serbian non supporté, fallback anglais
    'MG': { language: 'mg', domains: ['.mg'] }, // Madagascar - Malagasy non supporté, fallback français
    'MK': { language: 'mk', domains: ['.mk'] }, // North Macedonia - Macedonian non supporté, fallback anglais
    'ML': { language: 'fr', domains: ['.ml'] }, // Mali
    'MM': { language: 'my', domains: ['.mm'] }, // Myanmar - Myanmar non supporté, fallback anglais
    'MN': { language: 'mn', domains: ['.mn'] }, // Mongolia - Mongolian non supporté, fallback anglais
    'MO': { language: 'zh', domains: ['.mo'] }, // Macao
    'MR': { language: 'ar', domains: ['.mr'] }, // Mauritania
    'MT': { language: 'mt', domains: ['.mt'] }, // Malta - Maltese non supporté, fallback anglais
    'MU': { language: 'en', domains: ['.mu'] }, // Mauritius
    'MV': { language: 'dv', domains: ['.mv'] }, // Maldives - Dhivehi non supporté, fallback anglais
    'MW': { language: 'ny', domains: ['.mw'] }, // Malawi - Chichewa non supporté, fallback anglais
    'MX': { language: 'es', domains: ['.mx'] }, // Mexico
    'MY': { language: 'ms', domains: ['.my'] }, // Malaysia - Malay non supporté, fallback anglais
    'MZ': { language: 'pt', domains: ['.mz'] }, // Mozambique
    'NA': { language: 'en', domains: ['.na'] }, // Namibia
    'NE': { language: 'fr', domains: ['.ne'] }, // Niger
    'NG': { language: 'en', domains: ['.ng'] }, // Nigeria
    'NI': { language: 'es', domains: ['.ni'] }, // Nicaragua
    'NL': { language: 'nl', domains: ['.nl'] }, // Netherlands
    'NO': { language: 'no', domains: ['.no'] }, // Norway
    'NP': { language: 'ne', domains: ['.np'] }, // Nepal - Nepali non supporté, fallback anglais
    'NZ': { language: 'en', domains: ['.nz'] }, // New Zealand
    'OM': { language: 'ar', domains: ['.om'] }, // Oman
    'PA': { language: 'es', domains: ['.pa'] }, // Panama
    'PE': { language: 'es', domains: ['.pe'] }, // Peru
    'PH': { language: 'tl', domains: ['.ph'] }, // Philippines - Tagalog non supporté, fallback anglais
    'PK': { language: 'ur', domains: ['.pk'] }, // Pakistan - Urdu non supporté, fallback anglais
    'PL': { language: 'pl', domains: ['.pl'] }, // Poland
    'PT': { language: 'pt', domains: ['.pt'] }, // Portugal
    'PY': { language: 'es', domains: ['.py'] }, // Paraguay
    'QA': { language: 'ar', domains: ['.qa'] }, // Qatar
    'RO': { language: 'ro', domains: ['.ro'] }, // Romania
    'RS': { language: 'sr', domains: ['.rs'] }, // Serbia - Serbian non supporté, fallback anglais
    'RU': { language: 'ru', domains: ['.ru', '.рф'] }, // Russia
    'RW': { language: 'rw', domains: ['.rw'] }, // Rwanda - Kinyarwanda non supporté, fallback anglais
    'SA': { language: 'ar', domains: ['.sa'] }, // Saudi Arabia
    'SB': { language: 'en', domains: ['.sb'] }, // Solomon Islands
    'SC': { language: 'en', domains: ['.sc'] }, // Seychelles
    'SD': { language: 'ar', domains: ['.sd'] }, // Sudan
    'SE': { language: 'sv', domains: ['.se'] }, // Sweden
    'SG': { language: 'en', domains: ['.sg'] }, // Singapore
    'SI': { language: 'sl', domains: ['.si'] }, // Slovenia
    'SK': { language: 'sk', domains: ['.sk'] }, // Slovakia
    'SL': { language: 'en', domains: ['.sl'] }, // Sierra Leone
    'SN': { language: 'fr', domains: ['.sn'] }, // Senegal
    'SO': { language: 'so', domains: ['.so'] }, // Somalia - Somali non supporté, fallback anglais
    'SR': { language: 'nl', domains: ['.sr'] }, // Suriname
    'SV': { language: 'es', domains: ['.sv'] }, // El Salvador
    'SY': { language: 'ar', domains: ['.sy'] }, // Syria
    'TH': { language: 'th', domains: ['.th'] }, // Thailand - Thai non supporté, fallback anglais
    'TJ': { language: 'tg', domains: ['.tj'] }, // Tajikistan - Tajik non supporté, fallback russe
    'TM': { language: 'tk', domains: ['.tm'] }, // Turkmenistan - Turkmen non supporté, fallback anglais
    'TN': { language: 'ar', domains: ['.tn'] }, // Tunisia
    'TR': { language: 'tr', domains: ['.tr'] }, // Turkey
    'TT': { language: 'en', domains: ['.tt'] }, // Trinidad and Tobago
    'TW': { language: 'zh', domains: ['.tw'] }, // Taiwan
    'TZ': { language: 'sw', domains: ['.tz'] }, // Tanzania - Swahili non supporté, fallback anglais
    'UA': { language: 'uk', domains: ['.ua'] }, // Ukraine
    'UG': { language: 'en', domains: ['.ug'] }, // Uganda
    'US': { language: 'en', domains: ['.us', '.com'] }, // United States
    'UY': { language: 'es', domains: ['.uy'] }, // Uruguay
    'UZ': { language: 'uz', domains: ['.uz'] }, // Uzbekistan - Uzbek non supporté, fallback russe
    'VE': { language: 'es', domains: ['.ve'] }, // Venezuela
    'VN': { language: 'vi', domains: ['.vn'] }, // Vietnam - Vietnamese non supporté, fallback anglais
    'YE': { language: 'ar', domains: ['.ye'] }, // Yemen
    'ZA': { language: 'en', domains: ['.za'] }, // South Africa
    'ZM': { language: 'en', domains: ['.zm'] }, // Zambia
    'ZW': { language: 'en', domains: ['.zw'] }  // Zimbabwe
  };
  
  /**
   * Obtient les langues supportées pour un pays selon GeoLocalizer backend
   * avec fallback intelligent pour les langues non supportées
   */
  export const getBackendSupportedLanguages = (countryCode) => {
    const backendCountry = BACKEND_COUNTRY_MAPPING[countryCode];
    if (!backendCountry) return ['en'];
    
    const primaryLang = backendCountry.language;
    const supportedLanguages = [];
    
    // Ajouter la langue principale si supportée
    if (isLanguageSupported(primaryLang)) {
      supportedLanguages.push(primaryLang);
    } else {
      // Fallback intelligent pour langues non supportées
      const fallbackMapping = {
        'ca': 'es',      // Catalan -> Espagnol
        'fa': 'ar',      // Farsi -> Arabe
        'sq': 'en',      // Albanian -> Anglais
        'hy': 'ru',      // Armenian -> Russe
        'az': 'tr',      // Azeri -> Turc
        'bs': 'hr',      // Bosnian -> Croate
        'bn': 'en',      // Bengali -> Anglais
        'ms': 'en',      // Malay -> Anglais
        'dz': 'en',      // Dzongkha -> Anglais
        'be': 'ru',      // Belarusian -> Russe
        'ti': 'ar',      // Tigrinya -> Arabe
        'am': 'en',      // Amharic -> Anglais
        'ka': 'ru',      // Georgian -> Russe
        'ht': 'fr',      // Haitian Creole -> Français
        'ga': 'en',      // Irish Gaelic -> Anglais
        'hi': 'en',      // Hindi -> Anglais
        'is': 'en',      // Icelandic -> Anglais
        'sw': 'en',      // Swahili -> Anglais
        'ky': 'ru',      // Kyrgyz -> Russe
        'km': 'en',      // Khmer -> Anglais
        'kk': 'ru',      // Kazakh -> Russe
        'lo': 'en',      // Lao -> Anglais
        'si': 'en',      // Sinhala -> Anglais
        'st': 'en',      // Sesotho -> Anglais
        'lb': 'fr',      // Luxembourgish -> Français
        'sr': 'hr',      // Serbian -> Croate
        'mg': 'fr',      // Malagasy -> Français
        'mk': 'bg',      // Macedonian -> Bulgare
        'my': 'en',      // Myanmar -> Anglais
        'mn': 'zh',      // Mongolian -> Chinois
        'mt': 'en',      // Maltese -> Anglais
        'dv': 'ar',      // Dhivehi -> Arabe
        'ny': 'en',      // Chichewa -> Anglais
        'ne': 'en',      // Nepali -> Anglais
        'tl': 'en',      // Tagalog -> Anglais
        'ur': 'ar',      // Urdu -> Arabe
        'rw': 'fr',      // Kinyarwanda -> Français
        'so': 'ar',      // Somali -> Arabe
        'th': 'en',      // Thai -> Anglais
        'tg': 'ru',      // Tajik -> Russe
        'tk': 'tr',      // Turkmen -> Turc
        'uz': 'ru',      // Uzbek -> Russe
        'vi': 'en'       // Vietnamese -> Anglais
      };
      
      const fallbackLang = fallbackMapping[primaryLang];
      if (fallbackLang && isLanguageSupported(fallbackLang)) {
        supportedLanguages.push(fallbackLang);
      }
    }
    
    // Toujours ajouter l'anglais comme fallback final
    if (!supportedLanguages.includes('en')) {
      supportedLanguages.push('en');
    }
    
    // Ajouter des langues régionales pertinentes
    const regionalLanguages = getRegionalLanguages(countryCode);
    regionalLanguages.forEach(lang => {
      if (!supportedLanguages.includes(lang) && isLanguageSupported(lang)) {
        supportedLanguages.push(lang);
      }
    });
    
    return supportedLanguages.slice(0, 4); // Limiter à 4 langues max
  };
  
  /**
   * Obtient les langues régionales pertinentes pour un pays
   */
  const getRegionalLanguages = (countryCode) => {
    const regionalMapping = {
      // Europe
      'FR': ['fr', 'de', 'es', 'it'],
      'DE': ['de', 'fr', 'en', 'nl'],
      'ES': ['es', 'fr', 'pt', 'en'],
      'IT': ['it', 'fr', 'de', 'en'],
      'NL': ['nl', 'de', 'fr', 'en'],
      'BE': ['fr', 'nl', 'de', 'en'],
      'CH': ['de', 'fr', 'it', 'en'],
      'AT': ['de', 'it', 'fr', 'en'],
      'PL': ['pl', 'de', 'ru', 'en'],
      'CZ': ['cs', 'de', 'sk', 'en'],
      'SK': ['sk', 'cs', 'hu', 'en'],
      'HU': ['hu', 'de', 'sk', 'en'],
      'RO': ['ro', 'hu', 'bg', 'en'],
      'BG': ['bg', 'ro', 'el', 'en'],
      'GR': ['el', 'bg', 'it', 'en'],
      'HR': ['hr', 'sl', 'it', 'en'],
      'SI': ['sl', 'hr', 'it', 'en'],
      'RU': ['ru', 'uk', 'de', 'en'],
      'UA': ['uk', 'ru', 'pl', 'en'],
      
      // Amérique du Nord
      'US': ['en', 'es', 'fr'],
      'CA': ['en', 'fr'],
      'MX': ['es', 'en'],
      
      // Amérique du Sud
      'BR': ['pt', 'es', 'en'],
      'AR': ['es', 'pt', 'en'],
      'CL': ['es', 'pt', 'en'],
      'CO': ['es', 'pt', 'en'],
      'PE': ['es', 'pt', 'en'],
      'VE': ['es', 'pt', 'en'],
      'UY': ['es', 'pt', 'en'],
      
      // Asie
      'CN': ['zh', 'en'],
      'JP': ['ja', 'en'],
      'KR': ['ko', 'en'],
      'IN': ['en'],
      'ID': ['en'],
      'TH': ['en'],
      'VN': ['en'],
      'MY': ['en'],
      'SG': ['en'],
      'PH': ['en'],
      'TR': ['tr', 'de', 'en'],
      
      // Moyen-Orient
      'IL': ['he', 'ar', 'en'],
      'AE': ['ar', 'en'],
      'SA': ['ar', 'en'],
      'EG': ['ar', 'en'],
      'JO': ['ar', 'en'],
      'LB': ['ar', 'fr', 'en'],
      
      // Afrique du Nord
      'MA': ['ar', 'fr', 'en'],
      'DZ': ['ar', 'fr', 'en'],
      'TN': ['ar', 'fr', 'en'],
      
      // Afrique subsaharienne
      'ZA': ['en'],
      'NG': ['en'],
      'KE': ['en'],
      'GH': ['en'],
      'SN': ['fr', 'en'],
      'CI': ['fr', 'en'],
      
      // Océanie
      'AU': ['en'],
      'NZ': ['en']
    };
    
    return regionalMapping[countryCode] || ['en'];
  };
  
  /**
   * Vérifie si une langue est supportée
   */
  export const isLanguageSupported = (langCode) => {
    return AVAILABLE_LANGUAGES.some(lang => lang.code === langCode);
  };
  
  /**
   * Vérifie si un pays est supporté
   */
  export const isCountrySupported = (countryCode) => {
    return !!COUNTRY_LANGUAGE_CONFIG[countryCode];
  };
  
  /**
   * Obtient les domaines d'un pays
   */
  export const getCountryDomains = (countryCode) => {
    const config = COUNTRY_LANGUAGE_CONFIG[countryCode];
    return config && config.domains ? config.domains : ['.com', '.org'];
  };
  
  /**
   * Détection géographique simple
   */
  export const detectGeographicContext = (text) => {
    if (!text) return null;
    
    const lowerText = text.toLowerCase();
    const detectedCountries = [];
    
    const countryKeywords = {
      'france': 'FR', 'français': 'FR', 'french': 'FR', 'paris': 'FR',
      'allemagne': 'DE', 'germany': 'DE', 'deutsch': 'DE', 'german': 'DE', 'berlin': 'DE',
      'italie': 'IT', 'italy': 'IT', 'italiano': 'IT', 'italian': 'IT', 'rome': 'IT',
      'espagne': 'ES', 'spain': 'ES', 'español': 'ES', 'spanish': 'ES', 'madrid': 'ES',
      'royaume-uni': 'UK', 'uk': 'UK', 'britain': 'UK', 'british': 'UK', 'london': 'UK',
      'pays-bas': 'NL', 'netherlands': 'NL', 'holland': 'NL', 'amsterdam': 'NL',
      'belgique': 'BE', 'belgium': 'BE', 'bruxelles': 'BE', 'brussels': 'BE',
      'suisse': 'CH', 'switzerland': 'CH', 'schweiz': 'CH', 'bern': 'CH',
      'autriche': 'AT', 'austria': 'AT', 'vienna': 'AT',
      'pologne': 'PL', 'poland': 'PL', 'polska': 'PL', 'warsaw': 'PL',
      'suède': 'SE', 'sweden': 'SE', 'sverige': 'SE', 'stockholm': 'SE',
      'norvège': 'NO', 'norway': 'NO', 'norge': 'NO', 'oslo': 'NO',
      'danemark': 'DK', 'denmark': 'DK', 'danmark': 'DK', 'copenhagen': 'DK',
      'finlande': 'FI', 'finland': 'FI', 'suomi': 'FI', 'helsinki': 'FI',
      'portugal': 'PT', 'português': 'PT', 'lisbon': 'PT',
      'grèce': 'GR', 'greece': 'GR', 'greek': 'GR', 'athens': 'GR',
      'russie': 'RU', 'russia': 'RU', 'moscow': 'RU',
      'ukraine': 'UA', 'ukrainian': 'UA', 'kiev': 'UA',
      'états-unis': 'US', 'usa': 'US', 'america': 'US', 'american': 'US', 'washington': 'US',
      'canada': 'CA', 'canadian': 'CA', 'canadien': 'CA', 'ottawa': 'CA', 'quebec': 'CA',
      'mexique': 'MX', 'mexico': 'MX', 'mexican': 'MX',
      'brésil': 'BR', 'brazil': 'BR', 'brazilian': 'BR', 'brasil': 'BR', 'brasilia': 'BR',
      'argentine': 'AR', 'argentina': 'AR', 'buenos aires': 'AR',
      'chili': 'CL', 'chile': 'CL', 'chilean': 'CL', 'santiago': 'CL',
      'colombie': 'CO', 'colombia': 'CO', 'bogota': 'CO',
      'chine': 'CN', 'china': 'CN', 'chinese': 'CN', 'beijing': 'CN',
      'japon': 'JP', 'japan': 'JP', 'japanese': 'JP', 'tokyo': 'JP',
      'corée': 'KR', 'korea': 'KR', 'korean': 'KR', 'seoul': 'KR',
      'inde': 'IN', 'india': 'IN', 'indian': 'IN', 'delhi': 'IN', 'mumbai': 'IN',
      'indonésie': 'ID', 'indonesia': 'ID', 'jakarta': 'ID',
      'thaïlande': 'TH', 'thailand': 'TH', 'thai': 'TH', 'bangkok': 'TH',
      'vietnam': 'VN', 'vietnamese': 'VN', 'hanoi': 'VN',
      'malaisie': 'MY', 'malaysia': 'MY', 'kuala lumpur': 'MY',
      'singapour': 'SG', 'singapore': 'SG',
      'philippines': 'PH', 'manila': 'PH',
      'turquie': 'TR', 'turkey': 'TR', 'istanbul': 'TR', 'ankara': 'TR',
      'israël': 'IL', 'israel': 'IL', 'tel aviv': 'IL', 'jerusalem': 'IL',
      'émirats': 'AE', 'uae': 'AE', 'dubai': 'AE', 'abu dhabi': 'AE',
      'arabie': 'SA', 'saudi': 'SA', 'riyadh': 'SA',
      'égypte': 'EG', 'egypt': 'EG', 'cairo': 'EG',
      'jordanie': 'JO', 'jordan': 'JO', 'amman': 'JO',
      'liban': 'LB', 'lebanon': 'LB', 'beirut': 'LB',
      'maroc': 'MA', 'morocco': 'MA', 'marocain': 'MA', 'moroccan': 'MA', 'rabat': 'MA', 'casablanca': 'MA',
      'algérie': 'DZ', 'algeria': 'DZ', 'algiers': 'DZ',
      'tunisie': 'TN', 'tunisia': 'TN', 'tunis': 'TN',
      'afrique du sud': 'ZA', 'south africa': 'ZA', 'cape town': 'ZA', 'johannesburg': 'ZA',
      'nigeria': 'NG', 'lagos': 'NG', 'abuja': 'NG',
      'kenya': 'KE', 'nairobi': 'KE',
      'ghana': 'GH', 'accra': 'GH',
      'sénégal': 'SN', 'senegal': 'SN', 'dakar': 'SN',
      'australie': 'AU', 'australia': 'AU', 'sydney': 'AU', 'melbourne': 'AU', 'canberra': 'AU',
      'nouvelle-zélande': 'NZ', 'new zealand': 'NZ', 'auckland': 'NZ', 'wellington': 'NZ'
    };
    
    for (const [keyword, countryCode] of Object.entries(countryKeywords)) {
      if (lowerText.includes(keyword)) {
        const country = getCountryInfo(countryCode);
        if (country && !detectedCountries.find(c => c.code === countryCode)) {
          detectedCountries.push({
            code: countryCode,
            name: country.name
          });
        }
      }
    }
    
    return {
      countries: detectedCountries,
      hasGeographicContext: detectedCountries.length > 0
    };
  };
  
  /**
   * Génère une configuration optimisée basée sur un contexte
   */
  export const generateOptimizedConfig = (query, userLanguage = 'en', userCountry = '') => {
    const context = detectGeographicContext(query);
    let recommendedLanguages = [userLanguage];
    let recommendedCountry = userCountry;
    
    if (context && context.hasGeographicContext) {
      if (context.countries.length > 0) {
        recommendedCountry = context.countries[0].code;
        
        const countryLanguages = getRecommendedLanguages(recommendedCountry);
        recommendedLanguages = [
          userLanguage,
          ...countryLanguages.filter(lang => lang !== userLanguage)
        ].slice(0, 3);
      }
    }
    
    if (!recommendedLanguages.includes('en') && userLanguage !== 'en') {
      recommendedLanguages.push('en');
    }
    
    return {
      languages: recommendedLanguages,
      country: recommendedCountry,
      context: context,
      confidence: context && context.hasGeographicContext ? 0.8 : 0.3
    };
  };
  
  /**
   * Obtient les pays par région
   */
  export const getCountriesByRegion = (region) => {
    return AVAILABLE_COUNTRIES.filter(country => country.region === region);
  };
  
  /**
   * Obtient les langues par statut RTL
   */
  export const getRTLLanguages = () => {
    return AVAILABLE_LANGUAGES.filter(lang => lang.rtl).map(lang => lang.code);
  };
  
  /**
   * Constantes pour la compatibilité
   */
  export const SUPPORTED_REGIONS = [
    'Global',
    'Europe',
    'North America',
    'South America', 
    'Asia',
    'Middle East',
    'North Africa',
    'Africa',
    'Oceania',
    'Europe & Asia'
  ];
  
  // ============================================================================
  // EXPORT PAR DÉFAUT HARMONISÉ - CORRECTION POUR L'IMPORT
  // ============================================================================
  export default {
    // Données principales
    AVAILABLE_LANGUAGES,
    AVAILABLE_COUNTRIES,
    COUNTRY_LANGUAGE_CONFIG,
    SUPPORTED_REGIONS,
    BACKEND_COUNTRY_MAPPING,
    
    // Fonctions utilitaires
    getLanguageInfo,
    getCountryInfo,
    getRecommendedLanguages,
    getBackendSupportedLanguages, // AJOUT: Export de la fonction manquante
    isLanguageSupported,
    isCountrySupported,
    getCountryDomains,
    detectGeographicContext,
    generateOptimizedConfig,
    getCountriesByRegion,
    getRTLLanguages
  };
